import { useEffect } from 'react'
import { Search } from 'store/commonTypes'
import { useAppDispatch } from 'store/hooks'
import { actions as dashboardActions } from 'store/dashboard'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { Typography, Table, TableHead, TableRow, TableCell, TableBody, Box, Link, CircularProgress } from '@mui/material'
import { getReportLinkText } from 'containers/tables/searchStatusHelpers'

type MultisectorSearchesTableProps = {
  multisectorId: string
}

export default function MultisectorSearchesTable({ multisectorId }: MultisectorSearchesTableProps) {
  const dispatch = useAppDispatch()
  const multisectorSearches: Search[] | null = useSelector((state: RootState) => state.dashboard.multisectorSearches)
  const loading = useSelector((state: RootState) => state.dashboard.loading.multisectorSearches)
  const error = useSelector((state: RootState) => state.dashboard.error.multisectorSearches)
  const statusesWhereSearchHasFinished = ['search_finished', 'report_compiling', 'complete', 'report_error']

  useEffect(() => {
    if (multisectorId) {
      dispatch(dashboardActions.fetchMultisectorSearches(multisectorId))
    }
  }, [dispatch, multisectorId])

  if (loading) {
    return (
      <Box textAlign="center" p={2}>
        <CircularProgress />
      </Box>
    )
  }

  if (error) {
    return (
      <Typography color="error" p={2}>
        {error}
      </Typography>
    )
  }

  if (!multisectorSearches?.length) {
    return <Box p={2}>No searches found</Box>
  }

  return (
    <Box p={1} bgcolor={'#80808014'}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Origin</TableCell>
            <TableCell>Patent</TableCell>
            <TableCell>IPCR subgroup</TableCell>
            <TableCell>Single search report</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {multisectorSearches.map(search => (
            <TableRow key={search.ID}>
              <TableCell
                sx={{
                  maxWidth: 350,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}>
                {search.name}
              </TableCell>
              <TableCell>{search.status}</TableCell>
              <TableCell>{search.origin}</TableCell>
              <TableCell>{search.patent_number}</TableCell>
              <TableCell>{search.ipcr_subgroup}</TableCell>
              <TableCell>
                {getReportLinkText(search.status) ? (
                  <Link href={`/dashboard/reporting/single-search/${search.ID}`} target="_blank">
                    {getReportLinkText(search.status)}
                  </Link>
                ) : (
                  '-'
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  )
}
